import { useMemo } from 'react';

export function useTemplateProperties(properties) {
  return useMemo(() => ['new', 'deleted', ...properties], [properties]);
}
